import React, { useState, useEffect } from 'react'
import DashboardSideNav from '../../adminComponents/DashboardComponents/DashboardSideNav'
import DashboardHeader from '../../adminComponents/DashboardComponents/DashboardHeader'
import ContactTable from '../../adminComponents/ContactUsManagement/ContactTable'
import { ThreeCircles } from 'react-loader-spinner'
import { useSelector } from 'react-redux'
import Swal from 'sweetalert2'
import { AdminHeaderSearch, AdminListComments, AdvanceTableSearch } from '../../service/service'
import { Menu } from '@headlessui/react'
import { FilterIcon } from '../../assets/icon-file'

function ContactUsManagement() {

  const userPermissions = useSelector((state) => state.adminUser.userPermissions)
  const [isLoading, setIsLoading] = useState(false)
  const [isSearching, setIsSearching] = useState(false)
  const [responseData, setResponseData] = useState([]);
  const [noData, setNoData] = useState('')
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [filterData, setFilterData] = useState({
    name: '',
    email: '',
    comment: '',
  })
  const [headCells, setHeadCells] = useState([
    {
      id: 'Name',
      isShow: true
    },
    {
      id: 'Email',
      isShow: true
    },
    {
      id: 'Comment',
      isShow: true
    },
  ])
  function handlePageChange(selectedPage) {

    setCurrentPage(selectedPage.selected);
  }
  const itemsPerPage = 10; // Number of items per page

  useEffect(() => {
    if(isSearching){
      HandleTableSearch()
    }
    else{

      showDataList()
    }
  }, [currentPage, itemsPerPage])
  const showDataList = (message, pagecount) => {
    setIsLoading(true);
    const pagenum = pagecount ?? currentPage;
    AdminListComments(pagenum, itemsPerPage)
      .then((result) => {
        setIsLoading(false)
        if (result.status) {
          setResponseData(result.data.data)
          if (result?.data.data?.length === 0) {
            setNoData('No data to show')
          }
          const totalPages = Math.ceil(result.data.total / itemsPerPage);
          setTotalPages(totalPages)
          if (message) {
            Swal.fire({
              icon: 'success',
              title: message,
              showConfirmButton: false,
              timer: 1500
            })
          }
        }
        else {
          Swal.fire({
            title: 'Error!',
            text: result.message,
            icon: 'error',
            timer: 3000,
            confirmButtonText: 'OK'
          })
        }

      })
      .catch((error) => {
        setIsLoading(false)
        console.log(error.message);
        Swal.fire({
          title: 'Error!',
          text: error.message,
          icon: 'error',
          timer: 3000,
          confirmButtonText: 'OK'
        })
      });
  }
  const [searchTerm, setSearchTerm] = useState('');
  const performSearch = (searchTerm) => {

    AdminHeaderSearch('search-comments', searchTerm, currentPage, itemsPerPage)
      .then((result) => {
        setIsLoading(false)
        if (result.status) {
          setResponseData(result.data.data)
          if (result?.data.data?.length === 0) {
            setNoData('No data to show')
          }
          const totalPages = Math.ceil(result.data.total / itemsPerPage);
          setTotalPages(totalPages)

        }
        else {
          Swal.fire({
            title: 'Error!',
            text: result.message,
            icon: 'error',
            timer: 3000,
            confirmButtonText: 'OK'
          })
        }

      })

  };
  useEffect(() => {
    const getData = setTimeout(() => {
      if (searchTerm !== '') {
        performSearch(searchTerm);
      }
      if (searchTerm === '') {

        showDataList()
      }
    }, 1000)

    return () => clearTimeout(getData)
  }, [searchTerm])
  const handleCheckbox = (event) => {
    const { name, checked } = event.target;
    const index = parseInt(name.split('-')[1]); // Extracting the index from the name

    // Update the headCells state based on the checkbox change
    setHeadCells((prevHeadCells) =>
      prevHeadCells.map((item, idx) =>
        idx === index ? { ...item, isShow: checked } : item
      )
    );
  };
  const buttonElement =
    <div className='flex gap-x-4'>
      <Menu as="div" className="relative inline-block text-left">
        <Menu.Button
          className="flex gap-x-2 px-5 h-11 items-center justify-center rounded-3xl border-[1px] border-primaryBlue hover:bg-opacity-[0.9] text-sm md:text-base font-normal leading-7 text-primaryBlue shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
        >
          <span aria-hidden="true" className='text-[13px]'>
            <FilterIcon />
          </span>
          Filter

        </Menu.Button>
        <Menu.Items className="z-10 absolute right-0 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none">
          <div className="px-2 py-1 space-y-1">
            {headCells?.map((item, index) => (
              <div key={item.id} className='flex gap-2'>
                <input onChange={handleCheckbox} name={`item-${index}`} type="checkbox" checked={item.isShow} id={`item-${index}`} />
                <label htmlFor={`item-${index}`}>{item.id}</label>
              </div>
            ))}
          </div>
        </Menu.Items>
      </Menu>
    </div>;
  const inputElement = <div className='hidden lg:flex justify-between items-center border-[1px] border-[##D2D6DC] rounded-3xl pl-5 pr-2 w-[272px] h-[44px]'>
    <input value={searchTerm}
      onChange={(e) => setSearchTerm(e.target.value)}
      className='bg-transparent outline-none' type="text" placeholder='Search' />
    <div className='flex items-center justify-center  rounded-full h-[31px] w-[31px] bg-primaryBlue'>
      <svg className='relative right-[-1px]' width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.8086 12.8633C14.0547 13.1367 14.0547 13.5469 13.7812 13.793L13.0156 14.5586C12.7695 14.832 12.3594 14.832 12.0859 14.5586L9.37891 11.8516C9.24219 11.7148 9.1875 11.5508 9.1875 11.3867V10.9219C8.20312 11.6875 7 12.125 5.6875 12.125C2.54297 12.125 0 9.58203 0 6.4375C0 3.32031 2.54297 0.75 5.6875 0.75C8.80469 0.75 11.375 3.32031 11.375 6.4375C11.375 7.77734 10.9102 8.98047 10.1719 9.9375H10.6094C10.7734 9.9375 10.9375 10.0195 11.0742 10.1289L13.8086 12.8633ZM5.6875 9.9375C7.60156 9.9375 9.1875 8.37891 9.1875 6.4375C9.1875 4.52344 7.60156 2.9375 5.6875 2.9375C3.74609 2.9375 2.1875 4.52344 2.1875 6.4375C2.1875 8.37891 3.74609 9.9375 5.6875 9.9375Z" fill="white" />
      </svg>
    </div>
  </div>

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFilterData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };
  const HandleTableSearch = () => {

    const updatedData = {
      ...filterData,
      per_page: itemsPerPage,


    };
    setIsSearching(true)
    AdvanceTableSearch('advance-search-comments', updatedData, isSearching?currentPage :0)
      .then((result) => {
        setIsLoading(false)
        if (result.status) {
          setResponseData(result.data.data)
          if (result?.data.data?.length === 0) {
            setNoData('No data to show')
          }
          const totalPages = Math.ceil(result.data.total / itemsPerPage);
          setTotalPages(totalPages)

        }
        else {
          Swal.fire({
            title: 'Error!',
            text: result.message,
            icon: 'error',
            timer: 3000,
            confirmButtonText: 'OK'
          })
        }

      })

  }
  const ResetAdvanceSearch = () => {

    setFilterData({
      name: '',
      email: '',
      comment: '',
    })

    showDataList()
    setIsSearching(false)
  }
  return (
    <>
      {
        isLoading &&
        <div className="overlay">
          <div className="loaderImage-container">
            <ThreeCircles
              height="100"
              width="100"
              color="#F9F9F9"
              wrapperStyle={{}}
              wrapperClass=""
              visible={true}
              ariaLabel="three-circles-rotating"
              outerCircleColor=""
              innerCircleColor=""
              middleCircleColor=""
            />
          </div>
        </div>
      }
      <div className='bg-whiteGrey'>
        <DashboardSideNav />
        <main className="bg-[#D2D6DC] min-h-screen h-full sm:ml-[246px] lg:ml-[310px]">
          <DashboardHeader title={'Content'} subtitle={'Contact us'} Headerinput={inputElement} headerButton={buttonElement} />
          <div className='px-10 pt-8 flex flex-wrap gap-4 '>
            <div className='flex flex-col gap-4 flex-1 text-base font-semibold'>
              <label>
                Name
              </label>
              <input
                onChange={handleChange}
                value={filterData.name}
                className='bg-whiteGrey h-14 rounded-lg outline-none p-3' placeholder='Author Name' type="text" name="name" />
            </div>
            <div className='flex flex-col gap-4 flex-1 text-base font-semibold'>
              <label>
                Email
              </label>
              <input
                onChange={handleChange}
                value={filterData.email}
                className='bg-whiteGrey h-14 rounded-lg outline-none p-3' placeholder='Email' type="text" name="email" />
            </div>
            <div className='flex flex-col gap-4 flex-1 text-base font-semibold'>
              <label>
                Comment
              </label>
              <input
                onChange={handleChange}
                value={filterData.comment}
                className='bg-whiteGrey h-14 rounded-lg outline-none p-3' placeholder='Comment' type="text" name="comment" />
            </div>


            <div className='flex items-end pb-[6px]'>
              <button
                type="button"
                onClick={HandleTableSearch}
                className="flex gap-x-2 w-[137px] h-11 items-center justify-center rounded-3xl bg-primaryBlue hover:bg-opacity-[0.9] focus:bg-primaryBlue  text-sm md:text-base font-normal leading-7 text-whiteGrey shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
              >
                Search
                <span aria-hidden="true" className='text-[13px]'>
                  <svg className='relative right-[-1px]' width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.8086 12.8633C14.0547 13.1367 14.0547 13.5469 13.7812 13.793L13.0156 14.5586C12.7695 14.832 12.3594 14.832 12.0859 14.5586L9.37891 11.8516C9.24219 11.7148 9.1875 11.5508 9.1875 11.3867V10.9219C8.20312 11.6875 7 12.125 5.6875 12.125C2.54297 12.125 0 9.58203 0 6.4375C0 3.32031 2.54297 0.75 5.6875 0.75C8.80469 0.75 11.375 3.32031 11.375 6.4375C11.375 7.77734 10.9102 8.98047 10.1719 9.9375H10.6094C10.7734 9.9375 10.9375 10.0195 11.0742 10.1289L13.8086 12.8633ZM5.6875 9.9375C7.60156 9.9375 9.1875 8.37891 9.1875 6.4375C9.1875 4.52344 7.60156 2.9375 5.6875 2.9375C3.74609 2.9375 2.1875 4.52344 2.1875 6.4375C2.1875 8.37891 3.74609 9.9375 5.6875 9.9375Z" fill="white" />
                  </svg>
                </span>
              </button>
            </div>
            <div className='flex items-end pb-[6px]'>
              <button
                type="button"
                onClick={ResetAdvanceSearch}
                className="flex gap-x-2 px-8 h-11 items-center justify-center rounded-3xl border-[1px] border-primaryBlue hover:bg-opacity-[0.9] text-sm md:text-base font-normal leading-7 text-primaryBlue shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
              >
                Reset
              </button>
            </div>
          </div>
          <ContactTable
            responseData={responseData}
            totalPages={totalPages}
            currentPage={currentPage}
            noData={noData}
            setIsLoading={setIsLoading}
            handlePageChange={handlePageChange}
            userPermissions={userPermissions}
            showDataList={showDataList}
            setCurrentPage={setCurrentPage}
            headCells={headCells}
          />
        </main>
      </div>
    </>
  )
}

export default ContactUsManagement